import CustomerCompositionController from "../API/customer/CustomerCompositionController";

export const KITCHEN_CAROUSEL_CARDS_PER_VIEW = 3;
export const KITCHEN_CAROUSEL_API_PAGE_SIZE = 2;

export const getKitchenCarouselPageCount = (totalElements) =>
    Math.max(1, Math.ceil((totalElements || 0) / KITCHEN_CAROUSEL_CARDS_PER_VIEW));

const getMaxApiPageIndex = (totalElements) =>
    Math.max(0, Math.ceil(totalElements / KITCHEN_CAROUSEL_API_PAGE_SIZE) - 1);

/**
 * Загружает до 3 карточек для карусели через pageSize=2 (максимум, который принимает API).
 */
export const fetchKitchenCarouselCards = async (cornerType, carouselPageIndex) => {
    const startIndex = carouselPageIndex * KITCHEN_CAROUSEL_CARDS_PER_VIEW;
    const firstApiPage = Math.floor(startIndex / KITCHEN_CAROUSEL_API_PAGE_SIZE);
    const lastGlobalIndex = startIndex + KITCHEN_CAROUSEL_CARDS_PER_VIEW - 1;
    let lastApiPage = Math.floor(lastGlobalIndex / KITCHEN_CAROUSEL_API_PAGE_SIZE);

    const firstResponse = await CustomerCompositionController.get(
        "KITCHEN",
        cornerType,
        KITCHEN_CAROUSEL_API_PAGE_SIZE,
        firstApiPage,
    );
    const totalElements = firstResponse.data?.totalElements ?? 0;

    if (startIndex >= totalElements) {
        return {content: [], totalElements};
    }

    const maxApiPage = getMaxApiPageIndex(totalElements);
    if (firstApiPage > maxApiPage) {
        return {content: [], totalElements};
    }

    lastApiPage = Math.min(lastApiPage, maxApiPage);

    const apiPages = [];
    for (let page = firstApiPage; page <= lastApiPage; page += 1) {
        apiPages.push(page);
    }

    const responses = await Promise.all(
        apiPages.map((page) =>
            page === firstApiPage
                ? Promise.resolve(firstResponse)
                : CustomerCompositionController.get(
                    "KITCHEN",
                    cornerType,
                    KITCHEN_CAROUSEL_API_PAGE_SIZE,
                    page,
                ),
        ),
    );

    const combined = responses.flatMap((response) => response.data?.content ?? []);
    const offset = startIndex - firstApiPage * KITCHEN_CAROUSEL_API_PAGE_SIZE;

    return {
        content: combined.slice(offset, offset + KITCHEN_CAROUSEL_CARDS_PER_VIEW),
        totalElements,
    };
};
